import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule  } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PanelModule, Panel, InputTextModule, TabViewModule, OverlayPanelModule } from 'primeng/primeng';

import { FileUploadModule } from 'primeng/fileupload';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { TreeNode } from 'primeng/api';

import { NgxSpinnerModule } from 'ngx-spinner';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { BreadcrumbsComponent } from './layout/breadcrumbs/breadcrumbs.component';
import { ContentareaComponent } from './layout/contentarea/contentarea.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { RadioButtonModule } from 'primeng/radiobutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { DatePipe } from '@angular/common';
import {AccordionModule} from 'primeng/accordion';

// import { DropdownModule } from 'primeng/primeng';
// import {DataTableModule,SharedModule,InputTextModule,PanelModule,
// ButtonModule,MessagesModule,GrowlModule,TabViewModule,
//  ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

import { HomeComponent } from './home/home.component';
import { RegistrationComponent } from './registration/registration.component';
import { Observable } from 'rxjs/Observable';
import { LocalStorageModule, LocalStorage } from '@ngx-pwa/local-storage';
import { NgxPermissionsModule, NgxPermissionsGuard } from 'ngx-permissions';
import { HasLocationsGuard } from './services/guards/has-locations-guard';
import { AuthTokenService } from './services/appInitialization/authToken.service';
import { AuthUserService } from './services/appInitialization/authUser.service';
import { TokenInterceptor } from './services/appInitialization/token.Interceptor';
import { LookupService } from './services/lookups/lookup.service';
import { LookupAdminService } from './services/lookups/lookupadmin.service';
import { RegistrationService } from './services/registration.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { PostUserComponent } from './post-user/post-user.component';
import { HqUserComponent } from './hq-user/hq-user.component';
import { ReportdashboardComponent } from './reportdashboard/reportdashboard.component';
import { ReportlistingComponent } from './reportdashboard/reportlisting/reportlisting.component';
import { ReportsComponent } from './reports/reports.component';
import { RequiredreportscheduleComponent } from './requiredreportschedule/requiredreportschedule.component';

import { ReportService } from './services/report.service';
import { ReportdashboardService } from './services/reportdashboard.service';
import { ReportMetadataResolver } from './services/resolvers/reportMetadata.resolver';
import { ReportingInstructionsComponent } from './reportinginstructions/reportinginstructions/reportinginstructions.component';
import { FileuploadComponent } from './reportinginstructions/fileupload/fileupload.component';
//import { ReportlistingComponent } from './search/reportlisting/reportlisting.component';
import { SearchresultsComponent } from './search/searchresults/searchresults.component';

import { ExternaluserhomeComponent } from './home/externaluserhome/externaluserhome.component';
import { InternaluserhomeComponent } from './home/internaluserhome/internaluserhome.component';
import { AnnoucmentsComponent } from './home/annoucments/annoucments.component';
import { AlertsComponent } from './home/alerts/alerts.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { ReportfilterComponent } from './myreports/reportfilter/reportfilter.component';
import { ReportlineitemComponent } from './myreports/reportlineitem/reportlineitem.component';
import { CommentsComponent } from './myreports/comments/comments.component';
import { ReportassignmentComponent } from './reportassignment/reportassignment/reportassignment.component';
import { ReportscheduleComponent } from './reportschedule/reportschedule.component';
import { FAQComponent } from './faq/faq.component';
import { HelpComponent } from './help/help.component';

import { OAuthToken } from './models/oAuthToken.model';
import { ReportScheduleService } from './services/reportschedule.service';
import { RequiredreportscheduleService } from './services/requiredreportschedule.service';
import { RequiredrptmetadataComponent } from './reportdashboard/requiredrptmetadata/requiredrptmetadata.component';
import { VoluntaryrptmetadataComponent } from './reportdashboard/voluntaryrptmetadata/voluntaryrptmetadata.component';
import { HttpStatusNotifierService } from './services/http-status-notifier.service';
import { CanAccessDirective } from './directive/can-access.directive';
import { PermissionsService } from './services/permissions.service';
import { ReportworkflowComponent } from './reportdashboard/reportworkflow/reportworkflow.component';
import { ReporthistoryComponent } from './reportdashboard/reporthistory/reporthistory.component';
import { ReportingInstructionsService } from './services/reportinstructions.service';
import { SearchComponent } from './search/search.component';
import { AdminModule } from './admin/admin.module';
import { SearchService } from './services/search.service';
import { ReportattachmentsComponent } from './reportdashboard/reportattachments/reportattachments.component';
import {CookieService} from 'ngx-cookie-service';
import { QuickLinksComponent } from './quick-links/quick-links.component';
import { ReleaseNoteComponent } from './release-note/release-note.component';

// import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    ContentareaComponent,
    NavbarComponent,
    HomeComponent,
    RegistrationComponent,
    UserProfileComponent,
    PostUserComponent,
    HqUserComponent,
    ReportsComponent,
    ReportdashboardComponent,
    RequiredreportscheduleComponent,
    ReportingInstructionsComponent,
    FileuploadComponent,
    ReportlistingComponent,
    SearchresultsComponent,
    ExternaluserhomeComponent,
    InternaluserhomeComponent,
    AnnoucmentsComponent,
    AlertsComponent,
    DashboardComponent,
    ReportfilterComponent,
    ReportlineitemComponent,
    CommentsComponent,
    ReportassignmentComponent,
    ReportscheduleComponent,
    RequiredrptmetadataComponent,
    VoluntaryrptmetadataComponent,
    CanAccessDirective,
    ReportworkflowComponent,
    ReporthistoryComponent,
    SearchComponent,
    FAQComponent,
    HelpComponent,
    ReportattachmentsComponent,
    QuickLinksComponent,
    ReleaseNoteComponent
  ],
  imports: [
    AutoCompleteModule,
    BrowserModule,
    CheckboxModule,
    CalendarModule,
    MultiSelectModule,
    ListboxModule,
    DropdownModule,
    RadioButtonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LocalStorageModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    PanelModule,
    DialogModule,
    TabViewModule,
    InputTextModule,
    ConfirmDialogModule,
    NgxPermissionsModule.forRoot(),
    NgxSpinnerModule,
    NotifierModule,
    FileUploadModule,
    TreeModule,
    TreeTableModule,
    AccordionModule,
    OverlayPanelModule,
    RouterModule.forRoot(
      [
        {
          path: 'admin',
          loadChildren:()=>AdminModule,               //'./admin/admin.module#AdminModule',
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Admin']
            }
          }
        },
        {
          path: '',
          component: HomeComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              // User Activated w/ AppRole
              only: ['Activated'],
              redirectTo: 'registration'
            }
          }
        },
        {
          path: 'registration',
          component: RegistrationComponent,
          canDeactivate: [HasLocationsGuard],
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              // Guest User, New or Registered
              only: ['Guest', 'New', 'Registered', 'Deactivated'],
              redirectTo: ''
            }
          }
        },
        {
          path: 'user-profile',
          component: UserProfileComponent,
          canActivate: [NgxPermissionsGuard],
          canDeactivate: [HasLocationsGuard],
          data: {
            permissions: {
              // Registered
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
        },
        {
          path: 'reportinginstructions',
          component: ReportingInstructionsComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Author', 'Approver', 'Admin', 'Power User', 'SME']
            }
          }
        },
        {
          path: 'reports',
          component: ReportsComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Author', 'Approver', 'Admin', 'Power User']
            }
          }
        },
        {
          path: 'reportdashboard',
          component: ReportdashboardComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
          // canActivate: [NgxPermissionsGuard],
          // data: {
          //   permissions: {
          //     only: ['Author', 'Approver', 'Admin', 'Power User', 'SME']
          //   }
          // }
        },
        {
          path: 'requiredreportschedule',
          component: RequiredreportscheduleComponent,
          canActivate: [NgxPermissionsGuard],
          // canDeactivate: [HasLocationsGuard],
          data: {
            permissions: {
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
        },

        {
          path: 'reportschedule',
          component: ReportscheduleComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
        },
        {
          path: 'reports',
          component: ReportsComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
        },
        {
          path: 'search',
          component: SearchComponent,
          canActivate: [NgxPermissionsGuard],
          data: {
            permissions: {
              only: ['Registered', 'Activated'],
              redirectTo: ''
            }
          }
        },
        {
          path: 'faq',
          component: FAQComponent
          // canActivate: [NgxPermissionsGuard],
          // data: {
          // permissions: {
          //  redirectTo: ''
          // }
          // }
        },
        {
          path: 'help',
          component: HelpComponent
          // canActivate: [NgxPermissionsGuard],
          // data: {
          // permissions: {
          //  redirectTo: ''
          // }
          // }
        },
                {
          path: 'releasenote',
          component: ReleaseNoteComponent
          // canActivate: [NgxPermissionsGuard],
          // data: {
          // permissions: {
          //  redirectTo: ''
          // }
          // }
        },
        {
          path: 'quick-links/:dayCnt',
          component: QuickLinksComponent
          // canActivate: [NgxPermissionsGuard],
          // data: {
          // permissions: {
          //  redirectTo: ''
          // }
          // }
        }
      ]
      // , { onSameUrlNavigation: 'reload' }
       , {useHash: true}
    ),
    // DataTableModule,SharedModule,InputTextModule,
    // ButtonModule,PanelModule,TabViewModule,
    // MessagesModule,GrowlModule
    // ConfirmDialogModule,MessagesModule,GrowlModule
    TableModule,
    DropdownModule,
    InputTextareaModule
  ],
  providers: [
    HttpStatusNotifierService,
    HttpClient,
    CookieService,
    AuthTokenService,
    AuthUserService,
    LookupService,
    LookupAdminService,
    HasLocationsGuard,
    RegistrationService,
    ReportService,
    ReportdashboardService,
    ReportMetadataResolver,
    ReportScheduleService,
    RequiredreportscheduleService,
    ReportingInstructionsService,
    HttpStatusNotifierService,
    HttpClient,
    AuthTokenService,
    AuthUserService,
    LookupService,
    HasLocationsGuard,
    RegistrationService,
    ReportdashboardService,
    ReportMetadataResolver,
    ReportScheduleService,
    RequiredreportscheduleService,
    PermissionsService,
    SearchService,
    DatePipe,
    // { provide: APP_BASE_HREF, useValue: '', },
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: tokenSwapperFactory,
      deps: [AuthTokenService, AuthUserService, LocalStorage],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  exports: [HomeComponent]
})
export class AppModule {}

function getParameterByName(name) {
  // regex to get temp token from url
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getFixedToken() {
  // anonymous user token
  return '00000000-0000-0000-0000-00000000000000000000-0000-0000-0000-000000000000';
}

function getAuthTokenAndUser(
  authTokenService: AuthTokenService,
  authUserService: AuthUserService,
  localStorage: LocalStorage,
  tempToken
): Promise<any> {
  // clear local storage
  // localStorage.clear().subscribe(() => {});

  // use temptoken from url OR fixed
  // get OAuth Token & User object
  const p = authTokenService.swapToken(tempToken).then(t => {
    return authUserService.getAuthUser();
  });
  return p;
}

export function tokenSwapperFactory(
  authTokenService: AuthTokenService,
  authUserService: AuthUserService,
  localStorage: LocalStorage
): Function {
  return () => {
    console.log('In Token Swapper Factory');
    let tempToken = null;
    try {
      // get temp token in url
      tempToken = getParameterByName('tempToken');

      // no temp token in url
      if (tempToken == null) {
        // check local storage for oauth token
        return localStorage
          .getItem<OAuthToken>('oauth_token')
          .toPromise()
          .then(token => {
            // token exists in local storage to use
            if (token !== null) {
              // set AuthTokenService AuthToken variable
              // get User w/token
              authTokenService.AuthToken = token;
              return authUserService.getAuthUser();
            } else {
              // no oauth token in local storage

              // get anonymous user temptoken
              // invoke getAuthTokenAndUser
              tempToken = getFixedToken();
              return getAuthTokenAndUser(authTokenService, authUserService, localStorage, tempToken);
            }
          });
      } else {
        // temp token exists in url

        // invoke getAuthTokenAndUser
        return getAuthTokenAndUser(authTokenService, authUserService, localStorage, tempToken);
      }
    } catch (ex) {
      console.log(ex);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts